function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function retry(fn: () => void, retries = 5, delay = 300): Promise<void> {
  for (let i = 0; i < retries; i++) {
    try {
      fn();
      return; // If the function succeeds, exit the loop
    } catch (error) {
      if (i === retries - 1) return;
      await sleep(delay);
    }
  }
  throw new Error('Max retries reached');
}
